import React,{Component} from 'react'
import './Chat.css'
import FaCommentsO from "react-icons/lib/fa/comments-o";
import LiveChat from '../LiveChat/LiveChat'

import {connect} from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class Chat extends Component{
    render(){
        const {translate}=this.props
        return(
            <div className="chat">
                <LiveChat 
                    license={9502125}
                    onChatLoaded={ ref => this.livechat = ref }
                />
            </div>)
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});
export default  connect(mapStateToProps)(Chat);



// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js